import {styled, px} from '../../utils';
import BaseButton from './BaseButton';
import {PillButtonProps} from './types';
import {padding} from 'polished';

export default styled(BaseButton)<PillButtonProps>(
  ({large, theme}) => ({
    borderRadius: 25,
    fontFamily: theme.fontFamily.base,
    fontWeight: 'bold',
    fontSize: large ? 18 : 16,
    height: 55,
    lineHeight: px(55),
    ...padding(0, large ? 90 : 40)
  }),
  ({variant, theme}) => {
    let bgColor = theme.color.secondary;
    let textColor = '#fff';

    let bgColorHovered = theme.color.primary;
    let textColorHovered = '#fff';

    if (variant === 'primary') {
      bgColor = theme.color.primary;
      textColor = '#fff';

      bgColorHovered = theme.color.secondary;
      textColorHovered = '#fff';
    }

    if (variant === 'inverse') {
      bgColor = '#fff';
      textColor = theme.color.primary;

      bgColorHovered = '#fff';
      textColorHovered = theme.color.secondary;
    }

    return {
      backgroundColor: bgColor,
      color: textColor,
      ':hover': {
        backgroundColor: bgColorHovered,
        color: textColorHovered
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/components/Button/PillButton.tsx